export default {
  providersNames: []
};

export interface ProvidersState {
  providersNames: string[];
}
